import type {FileTreePayload} from '@github-ui/code-view-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export const codeViewFileTreeLayoutRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewFileTreeLayoutRoute', {
  path: '/:owner/:repo',
  queries: [
    mainQuery<FileTreePayload>({
      queryDeps: ({pathname}) => ({pathname: `${pathname}/_file_tree_layout`}),
    }),
  ],

  shouldRevalidate: ({currentParams, nextParams}) => {
    return currentParams.owner !== nextParams.owner || currentParams.repo !== nextParams.repo
  },
  tanStackRouterOptions: {
    // Aligned with UI Service. owner/repo are own path params, so TSR
    // already treats param changes as new matches — no reload needed.
    shouldReload: false,
  },
})
